// extracted by mini-css-extract-plugin
module.exports = {"bottomRight":"styles_bottomRight__KZGnZ","bottomRightInner":"styles_bottomRightInner__pSsOD","link":"styles_link__OOpBO","tel":"styles_tel__hXtsj","right":"styles_right__JwqAJ"};